/** Default form shape for “New partner” (admin create flow). */
export function createEmptyMedicalPartnerFormData() {
  return {
    _id: "",
    userId: "",
    organization_name: "",
    contact_person_name: "",
    contact_person_email: "",
    contact_person_phone: "",
    contact_person_country_code: "",
    contact_person_address: "",
    contact_person_city: "",
    contact_person_country: "",
    business_website: "",
    business_registration: "",
    organization_logo: "",
    default_logo: "",
    offersMedicalTourism: "yes",
    remarks: "",
    status: "",
    createdAt: "",
    slug: "",
    tcApprovalStatus: "off",
    defaultTimezone: "",
    defaultLanguage: "",
  };
}
